import React from 'react';
import { Card } from '../components/ui/Card';
import { UtensilsCrossed, ShoppingBag, Users, TrendingUp } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export const Dashboard: React.FC = () => {
  const {
    user
  } = useAuth();

  // Mock statistics
  const stats = [
    {
      title: 'Total Restaurants',
      value: '12',
      change: '+2',
    trend: 'up',
      icon: <UtensilsCrossed className="h-6 w-6 text-alps-primary" />,
      link: '/restaurants'
    },
    {
      title: 'Total Groceries',
      value: '5',
      change: '+1',
    trend: 'up',
      icon: <ShoppingBag className="h-6 w-6 text-alps-secondary" />,
      link: '/groceries'
    },
    {
    title: 'Total Users',
      value: '24',
      change: '+3',
    trend: 'up',
    icon: <Users className="h-6 w-6 text-alps-primary" />,
      link: '/settings'
    }
  ];

  // Recent activity (mock data)
  const recentActivity = [
    {
    id: 1,
      action: 'Restaurant Created',
      user: 'admin@example.com',
      details: 'Main Restaurant',
    time: '10 minutes ago',
    status: 'success'
    },
    {
    id: 2,
      action: 'User Created',
      user: 'admin@example.com',
      details: 'Partner Admin',
    time: '1 hour ago',
    status: 'success'
    },
    {
    id: 3,
      action: 'Grocery Created',
      user: 'admin@example.com',
      details: 'Main Grocery',
    time: '2 hours ago',
    status: 'success'
    }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-800">Dashboard</h1>
        <p className="mt-1 text-sm text-gray-600">Welcome back, {user?.name}</p>
      </div>
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {stats.map((stat, index) => (
          <a key={index} href={stat.link} className="block">
            <div className="bg-white rounded-lg shadow p-6 hover:shadow-md transition-shadow duration-200">
              <div className="flex justify-between items-start">
                <div>
                  <p className="text-sm font-medium text-gray-600">
                    {stat.title}
                  </p>
                  <p className="mt-1 text-3xl font-semibold text-gray-900">
                    {stat.value}
                  </p>
                </div>
                <div className="p-2 rounded-full bg-gray-50">{stat.icon}</div>
              </div>
              <div className="mt-4">
                <span
                  className={`text-sm font-medium ${
                    stat.trend === 'up' ? 'text-green-600' : 'text-red-600'
                  }`}
                >
                  {stat.change}
                  <TrendingUp className="inline-block h-4 w-4 ml-1" />
                </span>
                <span className="text-sm text-gray-500 ml-2">
                  vs last month
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Recent Activity */}
        <Card title="Recent Activity">
          <div className="divide-y divide-gray-200">
            {recentActivity.map((item) => (
              <div key={item.id} className="py-3 flex items-start">
                <div
                  className={`flex-shrink-0 h-3 w-3 rounded-full mt-2 ${
                    item.status === 'success'
                      ? 'bg-green-500'
                      : item.status === 'failed'
                      ? 'bg-red-500'
                      : 'bg-alps-primary'
                  }`}
                ></div>
                <div className="ml-3 flex-1">
                  <p className="text-sm font-medium text-gray-900">
                    {item.action}: {item.details}
                  </p>
                  <p className="text-sm text-gray-500">{item.user}</p>
                  <p className="text-xs text-gray-400 mt-0.5">{item.time}</p>
                </div>
              </div>
            ))}
          </div>
        </Card>
        {/* Quick Actions */}
        <Card title="Quick Actions">
          <div className="grid grid-cols-2 gap-4">
            <a
              href="/restaurants"
              className="flex flex-col items-center justify-center p-6 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <UtensilsCrossed className="h-8 w-8 text-alps-primary mb-2" />
              <span className="text-sm font-medium text-gray-900">
                Restaurants
              </span>
            </a>
            <a
              href="/groceries"
              className="flex flex-col items-center justify-center p-6 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <ShoppingBag className="h-8 w-8 text-alps-primary mb-2" />
              <span className="text-sm font-medium text-gray-900">
                Groceries
              </span>
            </a>
            {user?.role === 'Resort Super Admin' && (
              <a
                href="/settings"
                className="flex flex-col items-center justify-center p-6 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <Users className="h-8 w-8 text-alps-primary mb-2" />
                <span className="text-sm font-medium text-gray-900">
                  User Management
                </span>
              </a>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};
